// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"30ee5346","304":"9163ee86","357":"30ee5346"}[chunkId] + ".chunk.css";
};